import { useState } from "react";
import BidModal from "./BidModal";

/*
Purpose:
Displays single campaign details.

Features:
• campaign information
• budget display
• apply / bid button
*/

export default function CampaignCard({ campaign }) {

  const [showModal, setShowModal] = useState(false);

  return (

    <div className="bg-yellow-400 p-5 rounded-xl shadow-md">

      <h3 className="text-lg font-bold">
        {campaign.title}
      </h3>

      <p className="text-gray-600 mt-2">
        {campaign.description}
      </p>

      <p className="mt-3 text-balck font-semibold">
        Budget: ₹{campaign.budget}
      </p>

      <p className="text-sm text-gray-500">
        Bid Type: {campaign.bidType}
      </p>

      <button
        onClick={() => setShowModal(true)}
        className="mt-4 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
      >
        Apply / Bid
      </button>

      {/* Bid Modal */}

      {showModal && (
        <BidModal
          campaign={campaign}
          closeModal={() => setShowModal(false)}
        />
      )}

    </div>
  );
}